import { useState, useEffect } from "react"
import Cookies from 'js-cookie';
// import { useNavigate } from 'react-router-dom'
import Navbar from './NavBar';
import axios from "axios";
import { IoSyncSharp } from "react-icons/io5";
import { useParams } from 'react-router-dom'
import Nodata from '../../assets/No data.png'
import { toast,ToastContainer } from "react-toastify";
import { TailSpin } from 'react-loader-spinner'
import EachAccount from "./EachAccount";

const SuperAdminInstitutions =()=>{
    const token = Cookies.get('jwt_token')
    const [accessToken,setAccessToken]=useState('')
    const [institutionLoading,setInstitutionLoading]=useState(true)
    const [rotatingButtons, setRotatingButtons] = useState(false);
    const [institutions, setInstitutions] = useState([]);
    const [selectInsId,setSelectInsId]=useState('')
    const [selectInsName,setSelectInsName]=useState('')
    const [accountsLoader,setAccountsLoader]=useState(false)
    const [userAccountsData,setUserAccountsData]=useState([])

    const { id } = useParams();

    const getInstitutions=async(id)=>{
        try {
            setInstitutionLoading(true)
            const response = await axios.get(
              `https://bankdata.inclineanalytics.com/api/all-instiutions/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`
              }},
            );
            setInstitutions(response.data)
            if(response.data.length!==0){
              setSelectInsId(response.data[0].id)
              setSelectInsName(response.data[0].insName)
              if(selectInsId===''){
              setAccessToken(response.data[0].accessToken)
              }
            }
        } catch (error) {
            console.error("Error fetching institutions list", error);
            toast.error("Error fetching institutions, Try again!")
        }finally{
            setInstitutionLoading(false)
        }
    }

    useEffect(() => {
      getInstitutions(id)
      // eslint-disable-next-line
    }, [id]);

    useEffect(()=>{
        if(selectInsId!==''){
          loadAccounts(selectInsId)
        }
        // eslint-disable-next-line
    },[selectInsId])

    const loadAccounts=async(institutionId)=>{
        try { 
          setAccountsLoader(true)
          const response = await axios.get(
            `https://bankdata.inclineanalytics.com/api/all-accounts/${institutionId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`
              }},);
          if(response.data.success){
            setUserAccountsData(response.data.data)
          }
        } catch (error) {
          console.error("Error fetching user accounts:", error);
          }finally{
          setAccountsLoader(false)
          }
    }

    const syncDetails = async () => {
      try {
        setRotatingButtons(true);
        const data = {
          user_id: parseInt(id),
          access_token: accessToken,
          institutionId: selectInsId,
        };

        const response = await axios.post(
          "https://bankdata.inclineanalytics.com/api/sync-accounts-transactions",
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          loadAccounts(selectInsId);
        }

      } catch (error) {
        console.error("Error syncing details:", error);
        toast.error(error.response.data.message);
      } finally {
        setRotatingButtons(false);
      }
    };
    
    const handleSync=()=>{
      syncDetails()
    }

    const updateNoOfDaysFunction=async(values)=>{
      try{
        const {actual,
          changed,
          accountId}= values
          let url;
        if(actual===changed){
          toast.error('Value didnt change')
          return null
        }else if((actual===0)&& (changed!==0)){
          url = "https://bankdata.inclineanalytics.com/api/schedule-transaction-sync";
        }else{
          url = "https://bankdata.inclineanalytics.com/api/update-transaction-sync-interval";
        }
        const data = {
          user_id:parseInt(id),
          access_token:accessToken,
          accountId:accountId,
          intervalDays:parseInt(changed),
        }
        const response = await axios.post(
         url,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          toast.success(response.data.message);
          loadAccounts(selectInsId);
        }
      }catch (error) {
        console.error("Error setting sync details:", error);
        toast.error(error.response.data.message);
        getInstitutions(id)
      }
    }

    return(
        <div className='bg-[#001f3f] min-h-screen'>
            <Navbar />
            <ToastContainer/>
        <h1 className="text-left ml-10 mt-4 text-2xl font-semibold text-[#ff6f61]">Institution Details:</h1> 
            <div className="bg-[#ffffff] m-10 mt-0 mb-0 h-[75vh] rounded-lg">
              {institutionLoading?
              <div className="flex flex-col justify-center items-center h-[75vh]">
                <TailSpin
                    visible={true}
                    height="80"
                    width="80"
                    color="#ff6f61"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""/></div>:
              <>{institutions.length===0?
              <div className="flex flex-col h-full justify-center items-center">
                <img src={Nodata} alt="no-data" className="h-[350px]"/>
                <h1 className="text-2xl text-gray-800">No Institutions data found</h1>
              </div>:
        
         <div className="w-full p-10 pt-1 pb-1 flex flex-col items-center bg-[#ffffff] text-[#000000] rounded-md">
            <div className="w-full flex justify-between items-center">
              <ol className="min-h-[60px] text-sm flex items-center scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-gray-300 overflow-x-auto">
                {institutions.map((each)=><li key={each.id}>
                    <button
                    onClick={()=>{
                      setSelectInsId(each.id)
                      setAccessToken(each.accessToken)
                      setSelectInsName(each.insName)
                    }}
                    className={`border border-[#ff6f61] hover:border-[2px] hover:shadow-custom-orange m-1 p-2 text-start font-bold rounded-lg ${selectInsId===each.id?"bg-[#ff6f61] border-none text-[#ffffff]": 'text-gray-800'}`}>
                      {each.insName}
                      </button>
                  </li>)}
              </ol>
            </div>
          <hr className="border-gray-300 mt-0 w-full"/>
           
          {selectInsId!==''&&
          <div className="w-full h-[58vh] mt-0 bg-[#ffffff] text-[#000000] rounded-md"> 
          {accountsLoader?<div className="flex flex-col justify-center items-center h-[58vh]">
            <TailSpin
              visible={true}
              height="80"
              width="80"
              color="#ff6f61"
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperStyle={{}}
              wrapperClass=""/></div>:
          <div>
            <div className="flex justify-between items-center mt-1">
              <p className="text-left text-xl font-semibold text-[#ff6f61]">{selectInsName} Account Details:</p>
              <div className="w-fit mr-2 rounded-lg hover:shadow-custom-orange text-sm font-bold">
                  <button
                      disabled={rotatingButtons}
                      onClick={() => handleSync()}
                      className={`text-[#ff6f61] hover:border-[2px] border border-[#ff6f61] flex justify-center items-center rounded-lg`}
                  >
                      <p className="ml-2 m-1 ">Sync Transactions Now</p>
                      <p className={`m-1 mr-2 text-lg ${rotatingButtons ? "animate-spin" : ""}`}>
                          <IoSyncSharp />
                      </p>
                  </button>  
              </div>
            </div>
            <ol className="h-[58vh] flex flex-col w-full mt-1 p-2 text-md overflow-y-auto scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-gray-300">
          {userAccountsData.map((each,index)=>(
            <EachAccount data={each} index={index} updateNoOfDaysFunction={updateNoOfDaysFunction} rotatingButtons={rotatingButtons} key={each.id}/>
          ))}
          </ol>
          </div>}
        </div>}
         </div>         
        }</>
            }
            </div>
        </div>
    )
}
export default SuperAdminInstitutions